import React from 'react'

const PowersportFitIcon = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="27" height="27" rx="13.5" fill="#94B87C" />
    <path d="M10.3109 17.3949L6.11094 13.1949L4.71094 14.5949L10.3109 20.1949L22.3109 8.19492L20.9109 6.79492L10.3109 17.3949Z" fill="#3E3E47" />
  </svg>

)

export default PowersportFitIcon
